import React from 'react'
import { Route, Switch } from 'react-router-dom'
// import PageLayout from 'layouts/PageLayout'

const AppRouter = () => {
  return (
    <Switch>
      <Route
        path='/topic/supermarket'
        render={routeProps => (
          <div>
            {require('./Eid').default(routeProps)}
          </div>
        )}
      />
    </Switch>
  )
}

export default AppRouter
